import { render, staticRenderFns } from "./SortableTableHeader.vue?vue&type=template&id=6d29ce52&scoped=true"
import script from "./SortableTableHeader.vue?vue&type=script&lang=js"
export * from "./SortableTableHeader.vue?vue&type=script&lang=js"
import style0 from "./SortableTableHeader.vue?vue&type=style&index=0&id=6d29ce52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29ce52",
  null
  
)

export default component.exports